const types = {
	//Get Template name
	GET_EMPLOYEE_START: "GET_EMPLOYEE_START",
	GET_EMPLOYEE_SUCCESS: "GET_EMPLOYEE_SUCCESS",
	GET_EMPLOYEE_ERROR: "GET_EMPLOYEE_ERROR",
	GET_EMPLOYEE_RESET: "GET_EMPLOYEE_RESET",

	//Create Template name
	CREATE_EMPLOYEE_START: "CREATE_EMPLOYEE_START",
	CREATE_EMPLOYEE_SUCCESS: "CREATE_EMPLOYEE_SUCCESS",
	CREATE_EMPLOYEE_ERROR: "CREATE_EMPLOYEE_ERROR",
	CREATE_EMPLOYEE_RESET: "CREATE_EMPLOYEE_RESET",

	//delete Template name
	DELETE_EMPLOYEE_START: "DELETE_EMPLOYEE_START",
	DELETE_EMPLOYEE_SUCCESS: "DELETE_EMPLOYEE_SUCCESS",
	DELETE_EMPLOYEE_ERROR: "DELETE_EMPLOYEE_ERROR",
	DELETE_EMPLOYEE_RESET: "DELETE_EMPLOYEE_RESET",

	//update Template name
	UPDATE_EMPLOYEE_START: "UPDATE_EMPLOYEE_START",
	UPDATE_EMPLOYEE_SUCCESS: "UPDATE_EMPLOYEE_SUCCESS",
	UPDATE_EMPLOYEE_ERROR: "UPDATE_EMPLOYEE_ERROR",
	UPDATE_EMPLOYEE_RESET: "UPDATE_EMPLOYEE_RESET",

	//single item  name
	SINGLE_EMPLOYEE_START: "SINGLE_EMPLOYEE_START",
	SINGLE_EMPLOYEE_SUCCESS: "SINGLE_EMPLOYEE_SUCCESS",
	SINGLE_EMPLOYEE_ERROR: "SINGLE_EMPLOYEE_ERROR",
	SINGLE_EMPLOYEE_RESET: "SINGLE_EMPLOYEE_RESET",
};

export default types;
